var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 41,
    viewBox: "0 0 8 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18188 0.5C4.18188 0.223858 3.95803 0 3.68188 0C3.40574 0 3.18188 0.223858 3.18188 0.5H3.68188L4.18188 0.5ZM3.32833 40.8536C3.52359 41.0488 3.84018 41.0488 4.03544 40.8536L7.21742 37.6716C7.41268 37.4763 7.41268 37.1597 7.21742 36.9645C7.02216 36.7692 6.70557 36.7692 6.51031 36.9645L3.68188 39.7929L0.853458 36.9645C0.658195 36.7692 0.341613 36.7692 0.146351 36.9645C-0.0489113 37.1597 -0.0489113 37.4763 0.146351 37.6716L3.32833 40.8536ZM3.68188 0.5H3.18188L3.18188 40.5H3.68188H4.18188L4.18188 0.5L3.68188 0.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrow);
export default __webpack_public_path__ + "static/media/longArrow.f1916c952ed338e6568d919e11c149c6.svg";
export { ForwardRef as ReactComponent };